module.exports = __webpack_public_path__ + "img/6.ecb3046.svg";